import { CastToNumber, EnumSchema, Executor, FromSchema } from '@40seas/entities/common';
import { CreditLineRequestCancelReason } from '@40seas/entities/credit-line';
import { Currency, Segment, SegmentEntity, WithSegmentBaseEntitySchema } from '@40seas/models';
import { z } from 'zod';
import { UnderwritingResult, UnderwritingResultSchema } from './result/underwriting.result';
import { UnderwritingStatus } from './underwriting.status.enum';
import { PolicyResult, PolicyResultSchema } from './policy/policy.result';
import { ProcessResult, ProcessResultSchema } from './process/process.result';
import { ProcessType } from './process/process.type';

export const UnderwritingSchema = WithSegmentBaseEntitySchema(
    z.object({
        buyer: z.string().regex(/^[0-9a-f]{24}$/i),
        creditLineRequest: z
            .string()
            .regex(/^[0-9a-f]{24}$/i)
            .optional(),
        requestedAmount: CastToNumber(z.number()).optional(),
        cancelReason: EnumSchema(CreditLineRequestCancelReason).nullable().optional(),
        currency: EnumSchema(Currency).optional(),
        status: EnumSchema(UnderwritingStatus),
        result: UnderwritingResultSchema.optional(),
        processes: z.record(z.string(), ProcessResultSchema).optional(),
        policies: z.array(PolicyResultSchema).optional(),
        policyResult: PolicyResultSchema.nullish(),
    }),
).strict();

export class Underwriting extends FromSchema(UnderwritingSchema) implements SegmentEntity {
    id: string;
    buyer: string;
    creditLineRequest?: string;
    requestedAmount?: number;
    currency?: Currency;
    status: UnderwritingStatus;
    result?: UnderwritingResult;
    cancelReason?: CreditLineRequestCancelReason;
    processes?: Record<ProcessType, ProcessResult>;
    policies?: PolicyResult[];
    policyResult?: PolicyResult;

    createdAt: Date;
    updatedAt: Date;
    createdBy?: Executor;
    tenantId: string;
    seller?: string;
    segments?: Segment[];
    metadata?: { [key: string]: string };
    timeline?: { [status: string]: { updatedAt: Date } };
}
